import React, { Component } from "react";
import Header from "./Header";
import ChurnCalculator from "./ChurnCalculator";
import Footer from "./Footer";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      numCustomers: 1000,
      numChurned: 50,
      arpa: 30,
      churnImprovement: 10,
    };
  }

  render() {
    const { numCustomers, numChurned, arpa, churnImprovement } = this.state;

    const customersSavedCalc = (
      initial,
      improvement,
      iterations,
      arpaVal,
      currIter = 0,
      sum = 0,
      savedSum = 0,
      grid = []
    ) => {
      if (currIter === iterations) return [sum, savedSum, grid];

      const newlySaved = Math.round((initial - sum) * improvement);
      sum += newlySaved;
      savedSum += sum * arpaVal;
      grid[currIter] = {
        month: currIter,
        newlySaved,
        totalSaved: sum,
        revSavedThisMonth: sum * arpaVal,
        cumulativeRevSaved: savedSum,
      };

      currIter += 1;

      return customersSavedCalc(
        initial,
        improvement,
        iterations,
        arpaVal,
        currIter,
        sum,
        savedSum,
        grid
      );
    };

    const calcedData = customersSavedCalc(
      numChurned,
      churnImprovement / 100,
      12,
      arpa
    );

    return (
      <div className="App fw3">
        <Header />

        <ChurnCalculator {...this.state} calcedData={calcedData} />

        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js